export const fadeRise = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, delay: i * 0.09, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const maskLine = {
  hidden: { y: "115%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};

// Single elements are short, so requiring a quarter of them on screen reads as
// a deliberate reveal rather than a twitch at the edge of the viewport.
export const viewport = { once: true, amount: 0.25 };

// Groups are a different problem. A fractional `amount` is a fraction of the
// ELEMENT, not of the screen, so a one-column product grid 6,700px tall would
// need 1,686px visible at once — impossible on an 812px phone, and the whole
// grid stayed at opacity 0 forever. "some" fires as soon as any part of the
// group enters view, which is the behaviour we actually wanted, and it cannot
// deadlock no matter how many products the grid holds.
export const viewportGroup = { once: true, amount: "some" };
